var _defs, _path, _ellipse, _g, _ellipse2, _mask, _g2, _mask2, _g3, _g4, _use, _g5, _path2, _use2, _path3, _ellipse3, _path4, _path5, _path6, _path7, _rect, _polygon, _ellipse4, _ellipse5, _circle, _g6, _polyline, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillarBodyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "333px",
    height: "220px",
    viewBox: "0 0 333 220",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-healthy-bites-hero") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.4122371%",
    cy: "0%",
    fx: "49.4122371%",
    fy: "0%",
    r: "79.9715909%",
    gradientTransform: "translate(0.494122,0.000000),scale(0.396396,1.000000),rotate(90.000000),scale(1.000000,1.707647),translate(-0.494122,-0.000000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,12.710552),translate(-0.500000,-0.500000)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.112500,1.000000),rotate(90.000000),scale(1.000000,10.263689),translate(-0.489155,-0.509384)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.2925975%",
    y1: "83.7378561%",
    x2: "23.2013877%",
    y2: "4.632213%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.256273%",
    y1: "83.7378561%",
    x2: "49.1607561%",
    y2: "5.28989558%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,12.710552),translate(-0.500000,-0.500000)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.112500,1.000000),rotate(90.000000),scale(1.000000,10.263689),translate(-0.489155,-0.509384)",
    id: "radialGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.305615,0 L25.9418747,0.00351005878 C32.6891163,0.0783808533 38.1699264,1.3506823 42.240284,3.78828285 L42.240284,3.78828285 L42.5723319,3.99157882 C47.8334033,7.28434836 50.6110689,12.4950194 50.6110689,19.085769 L50.6110689,19.085769 L50.6095865,19.35517 C50.5523381,24.741656 48.8413745,40.3652063 46.229059,50.4310323 L46.0930752,50.9466968 C45.5006352,53.1588269 44.8635668,55.0780668 44.1903427,56.5265626 C43.8731541,57.2089955 43.4770898,57.8504824 43.0116149,58.4510234 L42.7732074,58.7478191 C41.9592916,59.725973 40.9569498,60.590388 39.810002,61.3410642 L39.4615594,61.5629175 C39.1502127,61.7557307 38.8290278,61.9405639 38.498819,62.117417 C37.3326439,62.7419062 36.0546386,63.2666869 34.7000249,63.6920456 L34.262728,63.8251826 C31.6240107,64.6031561 28.7155379,65.0126159 25.792866,65.0535619 L25.3056932,65.0569114 C24.3312036,65.0569114 23.3567138,65.0159654 22.391689,64.9340735 L21.9099455,64.8897153 C18.384069,64.5393998 15.0066528,63.6385883 12.2442862,62.187281 L11.8714825,61.9860259 C9.41194206,60.6211601 7.47823635,58.801339 6.42092299,56.5265626 C2.64042134,48.3927018 0,25.4150795 0,19.0858316 C0,18.9379887 0.00313036877,18.7918452 0.00599242022,18.6454334 L0.002,18.787 L0.00359631681,18.675649 C0.116799734,12.2787405 2.88734631,7.21574899 8.03914481,3.99157882 L8.37121429,3.78828285 L8.75690655,3.56317274 C12.9149506,1.19843477 18.4792753,0 25.305615,0 L25.305615,0 Z M25.305615,11.276125 L24.8823301,11.2779838 C13.0108091,11.3830297 11.4360155,15.9156163 11.2271143,18.6009611 L11.2238925,18.6454334 C11.195272,19.0381605 11.1951826,19.3901034 11.1951826,19.6809594 C11.1951826,23.4858779 12.962231,28.7120733 16.2372228,35.7580862 C16.3434067,35.9865475 16.4571128,36.2079356 16.5778754,36.4222506 L16.6428176,36.5357563 C16.7211121,36.6702939 16.8022202,36.8019776 16.8860226,36.9308074 C16.9155674,36.9762607 16.945576,37.0215192 16.9759171,37.0664199 L16.8860226,36.9308074 C17.0729372,37.2181523 17.2732551,37.4912998 17.4856518,37.7502498 C17.5172481,37.7888113 17.549134,37.8270455 17.5812832,37.864965 L17.4856518,37.7502498 C17.5507394,37.8296035 17.6169614,37.9076239 17.6842796,37.9843111 L17.5812832,37.864965 C17.6354835,37.9288936 17.6904323,37.9919279 17.7461086,38.0540679 L17.6842796,37.9843111 C17.7442396,38.0526162 17.8050694,38.1198635 17.8667418,38.1860531 L17.7461086,38.0540679 C17.8179256,38.1342226 17.8909531,38.2128894 17.965146,38.2900682 L17.8667418,38.1860531 C17.9255969,38.249219 17.9852194,38.3114216 18.0455861,38.3726609 L17.965146,38.2900682 C18.0412001,38.369183 18.1184788,38.4467343 18.1969338,38.522722 L18.0455861,38.3726609 C18.1134827,38.4415391 18.1823205,38.5091986 18.2520664,38.5756396 L18.1969338,38.522722 C18.4961588,38.812537 18.8124941,39.0796081 19.143254,39.3239355 C19.1613996,39.3373051 19.1796745,39.3507035 19.1979928,39.3640328 L19.143254,39.3239355 C19.2070487,39.3710597 19.27138,39.4173378 19.3362287,39.4627698 L19.1979928,39.3640328 C19.2804564,39.4240374 19.363799,39.4826418 19.4479796,39.5398459 L19.3362287,39.4627698 C19.5098212,39.5843864 19.6871207,39.6999402 19.8677577,39.8094314 C19.8856984,39.8202754 19.9027947,39.8305637 19.9199204,39.8407978 L19.8677577,39.8094314 C19.9659981,39.8689789 20.0652257,39.9267331 20.165381,39.9826941 L20.3865401,40.1025476 C20.4219096,40.1211385 20.4573866,40.1395115 20.4929685,40.1576668 L20.5621613,40.1926525 C20.5814589,40.2023093 20.6007866,40.2119024 20.6201441,40.221432 L20.6199405,40.221311 L20.7829444,40.2997336 L20.7829444,40.2997336 L20.9098702,40.3583122 C20.9421231,40.372926 20.9744509,40.3873683 21.0068518,40.4016391 L20.9102495,40.358502 C20.9936776,40.3962981 21.0776068,40.4329472 21.1620067,40.4684491 L21.0068518,40.4016391 C21.0944555,40.4402238 21.182594,40.4775552 21.2712325,40.5136332 L21.1620067,40.4684491 C21.3399519,40.5432999 21.5199895,40.6130515 21.7018344,40.677704 C21.8658211,40.7359982 22.0312305,40.7901415 22.1979,40.8401403 L22.198286,40.840261 L22.2860908,40.8661708 C22.3340863,40.8801118 22.3821828,40.8937109 22.4303753,40.9069682 L22.4381271,40.9091053 L22.5615694,40.9421582 C22.6136625,40.955771 22.6658618,40.9689872 22.718161,40.9818068 C22.8653059,41.0178675 23.0128437,41.0507086 23.1610316,41.0804267 C23.1969188,41.0876269 23.2325208,41.0945784 23.2681583,41.1013501 L23.1610316,41.0804267 C23.368455,41.1220239 23.5771521,41.1575023 23.786748,41.1868617 L23.7868349,41.1868836 L24.0541458,41.2209574 C24.1027651,41.2265446 24.151424,41.2318046 24.2001179,41.2367376 L24.3332755,41.2494047 C24.3867041,41.2541576 24.4401696,41.2585178 24.4936659,41.2624852 L24.3333205,41.2493943 C24.4256156,41.2576037 24.5180206,41.2646409 24.6105042,41.2705059 L24.6107801,41.2705401 L24.6778057,41.2745782 C24.6994789,41.2758191 24.7211561,41.2769958 24.7428368,41.278108 C24.7491563,41.2784375 24.7554941,41.2787571 24.7618321,41.2790712 L24.9175131,41.2856803 C24.9547524,41.2869966 24.9919988,41.2881234 25.0292502,41.2890607 L25.3057223,41.2925335 L25.3057223,41.2925335 L25.5832383,41.2890335 L25.5832383,41.2890335 L25.6133061,41.2882289 C25.6249917,41.2879017 25.6366767,41.2875559 25.6483612,41.2871914 C25.7231238,41.2848632 25.797879,41.2817667 25.8725925,41.2779063 C25.8929564,41.2768507 25.9132994,41.2757428 25.9336389,41.2745782 L26.0007416,41.2705059 C26.0401398,41.2680074 26.0795237,41.2652963 26.1188909,41.2623724 L26.1185736,41.2624235 L26.2034729,41.2557888 C26.226771,41.2538769 26.2500627,41.2518904 26.2733473,41.2498294 C26.2836769,41.2489126 26.2939873,41.2479853 26.3042963,41.2470432 L26.2733473,41.2498294 C26.3040073,41.2471154 26.3346553,41.2442722 26.36529,41.2412995 L26.3042963,41.2470432 C26.343657,41.2434465 26.3829972,41.2396366 26.4223143,41.2356133 L26.36529,41.2412995 C26.405652,41.237383 26.4459911,41.233242 26.4863045,41.2288765 L26.5256471,41.2245145 C26.58368,41.2180169 26.641658,41.2110536 26.6995732,41.2036247 L26.5252885,41.224584 C26.6252067,41.2134004 26.7249623,41.2008363 26.8245151,41.1868918 L26.6995732,41.2036247 C26.915511,41.1759257 27.1305763,41.1417534 27.3443613,41.1011077 C27.3806933,41.0942318 27.4171037,41.0871145 27.4534748,41.0798091 L27.3443613,41.1011077 C27.4535134,41.0803552 27.5623318,41.0579152 27.6707621,41.0337877 L27.8874165,40.9832344 C27.99394,40.9571872 28.1000498,40.9294949 28.2056938,40.9001574 C28.2463466,40.8888729 28.2869144,40.8773448 28.3274102,40.8655732 L28.4355314,40.8335074 L28.4355314,40.8335074 L28.5085,40.8111525 C28.6159984,40.7777897 28.7229529,40.7426927 28.829307,40.7058615 L28.9094585,40.677704 C29.0491764,40.6280298 29.1878273,40.5753454 29.3252819,40.5196508 L29.3260252,40.5193807 L29.3400448,40.5136868 C29.3807561,40.4971169 29.421362,40.4802826 29.4618591,40.463184 L29.6275927,40.3914588 C29.6412733,40.3853924 29.6549407,40.3792954 29.6685948,40.3731678 L29.6688756,40.3730108 L29.8555592,40.2869494 C29.8695988,40.2802993 29.8836234,40.2736162 29.8976329,40.2669001 L29.9641062,40.2346992 C30.0055506,40.2144522 30.0468599,40.1939146 30.0880301,40.1730863 L29.9635654,40.2349944 C30.0478955,40.1938026 30.1316661,40.1514075 30.2148448,40.107809 L30.0880301,40.1730863 C30.2085526,40.1121131 30.3278838,40.048649 30.4459263,39.9826941 L30.5626766,39.9164362 C30.6504955,39.8657716 30.7375725,39.813708 30.8238667,39.7602454 L30.9396631,39.6873626 C30.9604087,39.6740985 30.9811072,39.6607521 31.001758,39.6473236 L30.9393613,39.6875229 C31.0215451,39.6349808 31.1029901,39.5811486 31.18366,39.5260264 L31.001758,39.6473236 C31.081772,39.5952931 31.1610705,39.5420284 31.2396195,39.4875296 L31.18366,39.5260264 C31.4206329,39.3641015 31.6509173,39.1910442 31.8735937,39.0068546 C31.8982631,38.9864871 31.9225042,38.9662261 31.9466533,38.9458321 L32.1534714,38.7658383 C32.2225702,38.7038982 32.2908507,38.6408192 32.3582829,38.5766013 L32.3584592,38.5764809 C32.39187,38.5446522 32.4240723,38.5135249 32.4560754,38.4821347 L32.5619209,38.3766167 C32.5902164,38.3479469 32.6183487,38.3190656 32.6463154,38.2899729 L32.5618447,38.376642 C32.625836,38.3118039 32.6889927,38.2458845 32.7512869,38.1788837 L32.6463154,38.2899729 C32.7179654,38.2154381 32.7885286,38.1395155 32.8579643,38.0622053 L32.7512869,38.1788837 C32.8230059,38.1017459 32.8935817,38.0231748 32.9629717,37.9431705 L32.8579643,38.0622053 C32.915,37.9987013 32.971275,37.934261 33.0267669,37.8688844 L32.9629717,37.9431705 C33.0278572,37.8683597 33.0917059,37.7922957 33.154483,37.7149784 L33.1542451,37.7153433 L33.225995,37.6258499 C33.2515483,37.5935647 33.2769171,37.5610662 33.3020989,37.5283545 C33.3961508,37.4060998 33.4876085,37.2809286 33.5763298,37.1527822 L33.7215232,36.9367411 L33.7215232,36.9367411 L33.7253416,36.9308558 L33.7963969,36.8198192 C33.8260134,36.7728454 33.8552762,36.7255017 33.8841796,36.6777879 L33.7961612,36.8203063 C33.8488676,36.736724 33.900454,36.65197 33.9508891,36.5660446 L33.8841796,36.6777879 C33.9351317,36.5936764 33.9849671,36.508415 34.0336556,36.4220038 L34.0336252,36.422196 L34.1224032,36.2609457 C34.160926,36.1893581 34.1986743,36.1170065 34.2356314,36.0438911 L34.3742039,35.7580236 L34.629591,35.2055465 C37.7406214,28.4381063 39.4159758,23.3857753 39.4159758,19.6809862 L39.4159758,19.6809862 L39.4155796,19.4624396 C39.4142918,19.2197075 39.4090023,18.9443869 39.3872837,18.6454334 L39.3872837,18.6454334 L39.3840264,18.6009611 C39.1726689,15.884024 37.5631001,11.276125 25.305615,11.276125 L25.305615,11.276125 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.9%",
    y: "-7.7%",
    width: "119.8%",
    height: "115.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.41236413   0 0 0 0 0.41236413   0 0 0 0 0.41236413  0 0 0 0.605933129 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.84165856,52.8320355 C-1.84165856,61.059539 2.42038325,68.3639415 9.00972008,72.9538671 L9.00972008,72.9538671 C11.3455118,74.5809433 14.1780484,75.1761606 17.0511008,75.4469822 L17.0511008,75.4469822 C19.2613201,75.6553753 22.4644923,75.7700363 25.6165947,75.7700363 L25.6165947,75.7700363 L25.6491506,75.7700363 C28.6280989,75.7700363 31.558303,75.667539 33.5600397,75.4469822 L33.5600397,75.4469822 C36.428173,75.1311727 39.2657181,74.5809433 41.6015099,72.9538671 L41.6015099,72.9538671 C48.1746582,68.3751214 52.4320492,61.0954935 52.452799,52.8925858 L52.452799,52.8925858 L52.452799,52.7735423 C52.4188122,38.9059192 40.2775427,27.6737088 25.305615,27.6737088 L25.305615,27.6737088 C10.3125796,27.6737088 -1.84165856,38.9374018 -1.84165856,52.8320355",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "64.003653%",
    cy: "22.8598648%",
    fx: "64.003653%",
    fy: "22.8598648%",
    r: "116.996915%",
    gradientTransform: "translate(0.640037,0.228599),scale(0.885842,1.000000),rotate(128.137630),scale(1.000000,0.924562),translate(-0.640037,-0.228599)",
    id: "radialGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61EAB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC5D0",
    offset: "55.7823837%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8E2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.84165856,52.8320355 C-1.84165856,61.059539 2.42038325,68.3639415 9.00972008,72.9538671 L9.00972008,72.9538671 C11.3455118,74.5809433 14.1780484,75.1761606 17.0511008,75.4469822 L17.0511008,75.4469822 C19.2613201,75.6553753 22.4644923,75.7700363 25.6165947,75.7700363 L25.6165947,75.7700363 L25.6491506,75.7700363 C28.6280989,75.7700363 31.558303,75.667539 33.5600397,75.4469822 L33.5600397,75.4469822 C36.428173,75.1311727 39.2657181,74.5809433 41.6015099,72.9538671 L41.6015099,72.9538671 C48.1746582,68.3751214 52.4320492,61.0954935 52.452799,52.8925858 L52.452799,52.8925858 L52.452799,52.7735423 C52.4188122,38.9059192 40.2775427,27.6737088 25.305615,27.6737088 L25.305615,27.6737088 C10.3125796,27.6737088 -1.84165856,38.9374018 -1.84165856,52.8320355",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.5%",
    y: "-19.8%",
    width: "135.0%",
    height: "139.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.658823529   0 0 0 0 0.88627451  0 0 0 0.356151661 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.2914969,42.9414236 L40.2914969,49.5727645 L39.1101265,49.5727645 C38.4348274,49.5856754 37.8816946,49.0195341 37.8816946,48.343005 L37.8816946,48.343005 L37.8810815,47.1434236 L23.1785156,61.8653888 L14.2323338,52.9058969 C12.3186104,50.9892796 12.3186104,47.8706612 14.2326562,45.9540439 C14.2623113,45.9246717 14.2919665,45.8952994 14.3222663,45.8665728 C14.326779,45.862054 14.3316141,45.8578579 14.3361268,45.8536619 C14.3625586,45.8288085 14.388668,45.8046006 14.4150998,45.7803928 L14.4150998,45.7803928 C14.4763441,45.7248761 14.5346873,45.6745237 14.5939976,45.6257852 C14.7190649,45.5228211 14.8483227,45.426958 14.9814484,45.3375503 C15.1148966,45.2484653 15.2518904,45.1661586 15.39243,45.09063 C15.5329696,45.0154243 15.6770548,44.9473195 15.8240412,44.8863157 C15.9710275,44.8253119 16.1209149,44.771409 16.2737033,44.7252527 C16.4261694,44.6790964 16.5812142,44.6403638 16.7385154,44.6087322 C16.8954942,44.5777461 17.0550518,44.5541838 17.2158987,44.538368 C17.3770679,44.5225522 17.5395265,44.5144829 17.7035968,44.5144829 C17.8676671,44.5144829 18.0301256,44.5225522 18.1909725,44.538368 C18.3521418,44.5541838 18.511377,44.5777461 18.6686781,44.6087322 C18.8259793,44.6403638 18.9810241,44.6790964 19.1334902,44.7252527 C19.2859563,44.771409 19.436166,44.8253119 19.5831524,44.8863157 C19.7301387,44.9473195 19.874224,45.0154243 20.0147636,45.09063 C20.1553031,45.1661586 20.292297,45.2484653 20.4254228,45.3375503 C20.5588709,45.426958 20.6881286,45.5228211 20.8131959,45.6257852 C20.8708945,45.6735554 20.9279484,45.7226167 20.9840353,45.7732918 C20.986614,45.775874 20.9898374,45.7781334 20.9927385,45.7810383 C21.0162692,45.8023412 21.0397999,45.8242897 21.0630083,45.8462382 C21.070422,45.8533391 21.0781582,45.8601174 21.0852496,45.8672183 C21.1065239,45.8872302 21.1271536,45.9075648 21.1477833,45.9278994 C21.1568087,45.936937 21.1658342,45.945329 21.1745374,45.9540439 L21.1745374,45.9540439 L22.1766876,46.9575405 L22.4271446,47.208334 L22.6776016,47.4591275 L22.9283809,47.7102437 L23.1785156,47.9610372 L23.7822555,47.3564861 C24.2754334,46.8626457 24.75604,46.3481479 25.2672689,45.8720599 C25.2679135,45.8714144 25.2685582,45.8707688 25.2688805,45.8698005 L25.2688805,45.8698005 L25.2985357,45.8423649 C25.3001474,45.8410738 25.3014367,45.83946 25.3027261,45.8384917 C25.3175537,45.8249353 25.3320589,45.8110561 25.3468865,45.7974997 L25.3468865,45.7974997 L25.3504322,45.7939492 L25.4590602,45.698086 L25.4590602,45.698086 L25.466474,45.6916306 L25.466474,45.6916306 L25.4829133,45.6777514 C26.368377,44.9250483 27.4794777,44.5144829 28.6537568,44.5144829 C28.7224149,44.5144829 28.7904283,44.5160967 28.858764,44.5190017 C29.4189883,44.5390135 29.9785679,44.6532746 30.509137,44.868886 C30.5774727,44.8963216 30.6461308,44.9292443 30.7144666,44.9660402 C31.1908828,45.2236119 31.6547279,45.69389 31.8697276,46.2096789 C31.935807,46.367837 31.978678,46.5305138 31.9909269,46.6925451 C31.9980183,46.7900221 31.9915716,46.8829803 31.9741653,46.9730336 C31.935807,47.1679876 31.8445852,47.3458347 31.7240306,47.5117392 C31.47583,47.8532315 31.1054631,48.142112 30.827285,48.4200183 L30.827285,48.4200183 L30.8163255,48.4306697 C30.8021426,48.3996837 30.7873151,48.3686976 30.7715205,48.3383571 C30.7557259,48.307371 30.7392866,48.2773533 30.7218804,48.2470128 C30.7051188,48.2173178 30.6870678,48.1873 30.6686945,48.1579278 C30.6503212,48.1285556 30.6309809,48.0995062 30.6109959,48.0707795 L30.5805349,48.0277702 L30.5805349,48.0277702 L30.5491069,47.985245 C30.5278326,47.9571639 30.5059136,47.9297283 30.4827052,47.9026155 L30.4483359,47.861906 L30.4483359,47.861906 L30.4127578,47.8219227 C30.38826,47.7954554 30.36344,47.7689881 30.3379752,47.7434892 L30.2943387,47.7010851 L30.2943387,47.7010851 L30.2499768,47.6598914 C30.2457864,47.6560181 30.2412737,47.6527904 30.2374056,47.6489171 C30.2112962,47.6253548 30.1845421,47.602438 30.157788,47.5801668 C30.156821,47.579844 30.155854,47.5791985 30.1552093,47.5785529 C30.1255542,47.5543451 30.0952544,47.5311055 30.0646322,47.5085115 C30.0597971,47.5046383 30.0543174,47.5010878 30.0494823,47.4975373 C30.0230506,47.4784938 29.9966188,47.4594502 29.9695424,47.4416978 C29.9640626,47.4381473 29.9582605,47.4345968 29.9527808,47.4310463 C29.8618813,47.3716564 29.7674362,47.3190446 29.6707346,47.2735338 C28.8010654,46.8845942 27.7118838,47.0353285 26.9556777,47.7576911 L26.9556777,47.7576911 L25.7059715,49.0090763 L25.4252147,49.2902103 L25.0741881,49.6417085 L24.6003506,50.1161826 L24.126513,50.5906568 L23.6526755,51.0651309 L23.1785156,51.539605 L20.8093279,49.1672344 L20.3354903,48.6924375 L19.8616528,48.2182861 L19.3878153,47.7434892 C19.3855589,47.7412298 19.3829802,47.7392931 19.3807238,47.736711 C19.3542921,47.7105665 19.3272156,47.6847448 19.2998169,47.6598914 L19.2998169,47.6598914 L19.2840223,47.6460122 C19.2585575,47.6237409 19.2334151,47.6014697 19.207628,47.5804896 C19.205694,47.5791985 19.2040823,47.5779074 19.2024706,47.5766163 C18.3315121,46.8691011 17.0734251,46.8694239 16.2027889,47.5782302 C16.2018219,47.5788757 16.2008548,47.5795212 16.1998878,47.5801668 C16.1731337,47.6021153 16.146702,47.625032 16.1209149,47.6482716 C16.1164022,47.6521448 16.1118894,47.6556953 16.1073767,47.6598914 C16.0773992,47.6870042 16.0483888,47.7147625 16.0193783,47.7434892 C15.0907212,48.6733939 15.0907212,50.1865468 16.0193783,51.1164516 L16.0193783,51.1164516 L23.1788379,58.2864982 L36.0950815,45.3534236 L34.8974851,45.3541407 C34.26409,45.3541407 33.7270187,44.8676194 33.6729829,44.2496274 L33.6687308,44.1243812 L33.6687308,42.9414236 L40.2914969,42.9414236 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-5.3%",
    width: "107.3%",
    height: "110.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.4425578%",
    x2: "99.5574422%",
    y2: "50.4425578%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1472854,54.6290882 C20.0309977,54.859085 17.91471,57.044055 15.7984223,57.044055 C4.62912602,57.044055 -3.18938134,32.6991732 1.27833715,22.9612205 C5.74605564,13.2232677 18.0322815,18.0922441 22.5,18.0922441 L22.5,18.0922441 C26.9677185,18.0922441 39.2539444,13.2232677 43.7216629,22.9612205 C48.1893813,32.6991732 40.370874,57.044055 29.2015777,57.044055 C26.9677185,57.044055 24.7338592,54.6095669 22.5,54.6095669 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.7728069%",
    y1: "66.1826468%",
    x2: "87.1143501%",
    y2: "35.514944%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.100295608%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-30",
    cx: 71.9977134,
    cy: 28.8727134,
    r: 17.6707317
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.8%",
    y: "-2.8%",
    width: "105.7%",
    height: "105.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-31"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-32",
    cx: 71.875,
    cy: 28.75,
    r: 2.68333333
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-54.7%",
    y: "-36.0%",
    width: "209.3%",
    height: "209.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-33"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.933333333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.8171912%",
    fx: "48.9155431%",
    fy: "50.8171912%",
    r: "48.3563999%",
    gradientTransform: "translate(0.489155,0.508172),scale(0.075949,1.000000),rotate(90.000000),scale(1.000000,13.555189),translate(-0.489155,-0.508172)",
    id: "radialGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.4163373%",
    y1: "83.7378561%",
    x2: "26.5271288%",
    y2: "4.632213%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.759637,73.0201222 C88.7465901,73.7712576 86.8925623,76.5672652 85.1975535,81.4081449 C83.5807775,86.0255948 81.6929542,93.6908094 79.5340836,104.403789 C79.3486644,105.324015 79.8281818,106.249374 80.6869384,106.628495 L93.8706464,112.448803 C94.7878865,112.853744 95.8632114,112.516933 96.3855508,111.661089 L103.246647,100.419313 C103.701293,99.6743829 104.586465,99.3102589 105.433682,99.5196538 L122.916743,103.840696 C123.843047,104.069637 124.802076,103.612342 125.207299,102.748485 L131.228893,89.9116261 C131.679245,88.9515634 131.301978,87.8068912 130.369043,87.3027386 L110.468053,76.5483596 L110.468053,76.5483596 L110.83588,75.6138807 C111.038162,75.0999738 110.78554,74.5193877 110.271633,74.3171054 C110.214946,74.2947921 110.156337,74.2777057 110.09654,74.2660593 L91.9508077,70.7319481 C91.4087088,70.6263675 90.8836608,70.9802355 90.7780802,71.5223343 C90.7658132,71.5853186 90.759637,71.6493373 90.759637,71.713505 L90.759637,73.0201222 L90.759637,73.0201222 Z",
    id: "path-36"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.2%",
    y: "-6.5%",
    width: "109.7%",
    height: "112.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-37"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "77.3276635%",
    x2: "19.6413923%",
    y2: "13.2520925%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "events-icon_body",
    transform: "translate(0.000000, -31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-healthy-bites-hero",
    transform: "translate(0.000000, 31.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.5,132 C258.455411,132 333,72.901587 333,0 C312.416209,0 24.2431319,0 0,0 C0,72.901587 74.5445892,132 166.5,132 Z",
    id: "sky",
    fill: "url(#radialGradient-1)",
    opacity: 0.55363537,
    transform: "translate(166.500000, 66.000000) scale(1, -1) translate(-166.500000, -66.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-health-quiz-copy-3",
    transform: "translate(207.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "water",
    transform: "translate(0.000000, 40.781250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-small-01",
    transform: "translate(0.000000, 34.453125)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-2)",
    cx: 15.75,
    cy: 1.4765625,
    rx: 15.75,
    ry: 1.4765625
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-3)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 15.75,
    cy: 0.984375,
    rx: 8.75,
    ry: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cup",
    transform: "translate(0.576220, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6365052,0 C30.4943622,0.570569323 30.7272548,1.7285376 30.1566855,2.58639453 C30.0195384,2.79259658 29.8427073,2.96942769 29.6365052,3.10657476 L29.6365052,3.10657476 L29.6365052,3.10657476 L25.8603851,34.7519244 C25.7941031,35.307393 25.3230153,35.7256098 24.763606,35.7256098 L5.70633775,35.7256098 C5.14692848,35.7256098 4.67584059,35.307393 4.60955862,34.7519244 L0.833438506,3.10657476 L0.833438506,3.10657476 C-0.024418426,2.53600544 -0.257311048,1.37803716 0.313258275,0.520180232 C0.450405347,0.313978178 0.627236453,0.137147072 0.833438506,4.23217017e-13 L0.833438506,0 L0.833438506,0 L29.6365052,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7931185,16.7103659 C15.7931185,15.5485726 15.7931185,10.7767738 15.7931185,3.45731707 C15.7931185,-3.86213966 15.7931185,-9.07283814 15.7931185,-9.79573171 C15.3449885,-9.79573171 14.9817073,-3.86213966 14.9817073,3.45731707 C14.9817073,10.7767738 15.3449885,16.7103659 15.7931185,16.7103659 Z",
    id: "Oval",
    fill: "url(#linearGradient-5)",
    opacity: 0.100000001,
    transform: "translate(15.387413, 3.457317) rotate(-90.000000) translate(-15.387413, -3.457317) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6424234,9.65626988 L23.9895537,33.562614 C23.9657555,33.7770709 23.7844955,33.9393293 23.5687222,33.9393293 L6.90122153,33.9393293 C6.68544827,33.9393293 6.50418819,33.7770709 6.48039006,33.562614 L3.82752029,9.65626988 L3.82752029,9.65626988 L26.6424234,9.65626988 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 19.7609397,
    cy: 30.9621951,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 14.3715925,
    cy: 28.5804878,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 8.38342898,
    cy: 15.4810976,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 10.7786944,
    cy: 11.3131098,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-7)",
    points: "9.62823453 4.54813887 4.88487653 4.54813887 8.98224534 32.782895"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small-01",
    transform: "translate(43.593750, 85.781250)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-8)",
    cx: 22.5,
    cy: 2.109375,
    rx: 22.5,
    ry: 2.109375
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-9)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 22.5,
    cy: 1.40625,
    rx: 12.5,
    ry: 1.40625
  })), /*#__PURE__*/React.createElement("g", {
    id: "kettlebell-+-tape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kettlebell",
    transform: "translate(19.740376, 0.000000)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-10"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-9",
    mask: "url(#mask-14)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-15)",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    mask: "url(#mask-14)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-18"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "tape",
    transform: "translate(0.000000, 59.062500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.532,0 L20.008,0 C20.2907698,5.90783344e-17 20.52,0.229230208 20.52,0.512 L20.52,13.888 C20.52,14.1707698 20.2907698,14.4 20.008,14.4 L1.532,14.4 C1.24923021,14.4 1.02,14.1707698 1.02,13.888 L1.02,0.512 C1.02,0.229230208 1.24923021,4.96033178e-16 1.532,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.720000, 7.920000)",
    fill: "#2CB5D6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.6,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.2,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.8,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.4,
    y: 0,
    width: 1,
    height: 6.48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(79.453125, 7.734375) scale(-1, 1) translate(-79.453125, -7.734375) translate(68.906250, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-20)",
    x: 1.02,
    y: 0,
    width: 19.5,
    height: 14.4,
    rx: 0.512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.720000, 7.920000)",
    fill: "#2CB5D6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.6,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.2,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.8,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.4,
    y: 0,
    width: 1,
    height: 6.48
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.6363122,-0.154118647 L14.04,5.75309981 L14.04,5.75309981 L20.52,5.75309981 L20.52,0.198006613 C20.52,-0.0847631791 20.2907698,-0.313993387 20.008,-0.313993387 C19.8674087,-0.313993387 19.7330032,-0.256181289 19.6363122,-0.154118647 Z",
    id: "Path-31",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0763122,-0.154118647 L69.48,5.75309981 L69.48,5.75309981 L75.96,5.75309981 L75.96,0.198006613 C75.96,-0.0847631791 75.7307698,-0.313993387 75.448,-0.313993387 C75.3074087,-0.313993387 75.1730032,-0.256181289 75.0763122,-0.154118647 Z",
    id: "Path-31",
    fill: "#575756",
    transform: "translate(72.720000, 2.876550) scale(-1, 1) translate(-72.720000, -2.876550) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(13.320000, 5.760000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F8F8",
    x: 0,
    y: 0,
    width: 63.36,
    height: 14.4,
    rx: 0.512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.320000, 7.920000)",
    fill: "#2CB5D6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1,
    height: 6.48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 43.2,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 21.6,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.6,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 46.8,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 25.2,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.2,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 50.4,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 28.8,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.8,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 54,
    y: 0,
    width: 1,
    height: 6.48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 32.4,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 14.4,
    y: 2.88,
    width: 1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 36,
    y: 0,
    width: 1,
    height: 6.48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 18,
    y: 0,
    width: 1,
    height: 6.48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 39.6,
    y: 2.88,
    width: 1,
    height: 3.6
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(43.593750, 30.937500)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6284559,10.4025873 C34.4127383,10.2586483 37.5673802,7.75763175 37.6108176,6.56546627 C37.6542551,5.3733008 34.6733629,3.10565547 30.8890805,3.24959448 C27.1047981,3.39353349 23.9501562,5.89455007 23.9067187,7.08671554 C23.8632813,8.27888102 26.8441734,10.5465263 30.6284559,10.4025873 Z",
    id: "Oval",
    fill: "#575756",
    transform: "translate(30.758768, 6.826091) rotate(-30.000000) translate(-30.758768, -6.826091) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-21)",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7505336,24.0751227 C32.0164254,24.0751227 37.265625,16.6024303 41.2823173,24.0751227 C45.2990095,31.5478151 29.20979,41.4630135 27.9497552,42.6180553 C26.6897205,43.7730971 25.1810664,41.3727165 22.4123776,41.3727165 C19.6436888,41.3727165 18.984375,44.0243053 16.875,42.6180553 C14.765625,41.2118053 -0.703125,30.8446901 4.21875,24.0751227 C9.140625,17.3055553 13.4846418,24.0751227 22.7505336,24.0751227 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-23)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(11.250000, 27.852430) rotate(-315.000000) translate(-11.250000, -27.852430) ",
    cx: 11.25,
    cy: 27.8524303,
    rx: 4.21875,
    ry: 4.921875
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.203125,21.09375 C26.6980519,21.09375 29.53125,19.8345509 29.53125,18.28125 C29.53125,16.7279491 26.6980519,15.46875 23.203125,15.46875 C19.7081981,15.46875 16.875,16.7279491 16.875,18.28125 C16.875,19.8345509 19.7081981,21.09375 23.203125,21.09375 Z",
    id: "Oval",
    fill: "url(#linearGradient-24)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7581689,19.2768804 C26.2625211,13.5775346 24.7030022,9.14627305 20.1036735,6.24212551 C19.5650496,5.90202302 18.8373147,6.03987679 18.4782322,6.55003053 C18.1191496,7.06018426 18.2646966,7.74945311 18.8033204,8.0895556 C22.5390841,10.4484235 23.7579293,13.9116851 22.4839174,18.7383702 C22.3269131,19.3331922 22.7087445,19.9359403 23.3367617,20.0846458 C23.9647789,20.2333513 24.6011646,19.8717024 24.7581689,19.2768804 Z",
    id: "Path-64",
    fill: "#575756",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-gp-anytime",
    transform: "translate(39.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 86.250000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-25)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 46,
    cy: 2.875,
    rx: 46,
    ry: 2.875
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-26)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 46,
    cy: 2.15625,
    rx: 23,
    ry: 2.15625
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2231105,58.9375 C21.6993702,58.9375 24.4375,57.4385027 24.4375,54.440508 C24.4375,11.9418551 15.1324721,11.9418551 0,2.875",
    id: "Oval",
    stroke: "#D9D9D9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    transform: "translate(12.218750, 30.906250) rotate(-180.000000) translate(-12.218750, -30.906250) "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2231105,58.9375 C44.6993702,58.9375 47.4375,57.4385027 47.4375,54.440508 C47.4375,11.9418551 38.1324721,11.9418551 23,2.875",
    id: "Oval",
    stroke: "#D9D9D9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    transform: "translate(35.218750, 30.906250) scale(-1, 1) rotate(-180.000000) translate(-35.218750, -30.906250) "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5625,36.3473136 C45.9239849,36.3473136 47.0276864,37.4510151 47.0276864,38.8125 C47.0276864,39.122302 47.0091387,39.4281021 46.9726656,39.7296932 C47.0715912,40.1872527 47.0418745,40.6777457 46.8590735,41.1462674 C44.1235632,48.157423 40.3358281,51.7595729 32.8390892,55.8105548 C32.7076216,55.8815954 28.8097939,57.9263515 26.6167087,59.1154185 L26.6166109,61.8168515 L26.6166109,61.8168515 C26.4027087,71.35942 35.6078107,77.6060855 47.9621566,77.6060855 C60.3265805,77.6060855 69.648507,71.3439866 69.5777857,61.7681062 L69.5777857,42.40625 C69.5777857,41.2049398 70.55164,40.2310855 71.7529502,40.2310855 C72.9542603,40.2310855 73.9285995,41.2049398 73.9285995,42.40625 L73.9283855,58.3834745 C73.9283821,58.4271556 73.9283787,58.4708268 73.9283752,58.5145187 L73.9280552,61.7520288 L73.9280552,61.7520288 C74.0199791,74.1883516 62.4562347,81.9564145 47.9621566,81.9564145 C33.4580004,81.9564145 21.9882208,74.1729182 22.2668282,61.7681062 L22.2666434,59.8542631 C22.1048362,59.8036623 21.9458299,59.7355066 21.7921269,59.6490947 C20.1196421,58.7088223 14.7532839,55.894122 14.5986347,55.8105548 C7.10189582,51.7595729 3.31416068,48.157423 0.578650372,41.1462674 C0.396245932,40.678762 0.366262363,40.1893806 0.464633839,39.732983 C0.428484028,39.4301228 0.409813596,39.1233256 0.409813596,38.8125 C0.409813596,37.4510151 1.51351514,36.3473136 2.875,36.3473136 C4.23648486,36.3473136 5.3401864,37.4510151 5.3401864,38.8125 C5.3401864,42.5192771 13.3991548,46.4098136 23.71875,46.4098136 C34.0383452,46.4098136 42.0973136,42.5192771 42.0973136,38.8125 C42.0973136,37.4510151 43.2010151,36.3473136 44.5625,36.3473136 Z M32.167658,50.5386478 L31.9888729,50.5736011 C29.4089554,51.0734328 26.6185248,51.3401864 23.71875,51.3401864 C20.7520023,51.3401864 17.8997079,51.0609687 15.2702088,50.5385964 C15.8002782,50.8460349 16.3570831,51.1566042 16.9425246,51.4729569 C17.0332059,51.521958 21.6235836,53.9297656 23.7201176,55.0806379 C25.8141403,53.9297656 30.404518,51.521958 30.4951993,51.4729569 C31.0806408,51.1566042 31.6374457,50.8460349 32.167658,50.5386478 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-27)",
    fillRule: "nonzero"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-28)",
    opacity: 0.5,
    x: 69.575,
    y: 48.875,
    width: 4.3125,
    height: 5.75
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    points: "69.8214286 40.25 64.6875 34.7317658 66.1352679 33.1756238 69.8214286 37.1266795 77.6147321 28.75 79.0625 30.3171785"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#575756",
    cx: 12.21875,
    cy: 4.3125,
    rx: 5.03125,
    ry: 4.3125
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#575756",
    cx: 36.65625,
    cy: 4.3125,
    rx: 5.03125,
    ry: 4.3125
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#575756",
    strokeWidth: 0.933333333,
    fill: "#575756",
    cx: 71.9977134,
    cy: 28.8727134,
    r: 20.3462398
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-29)",
    fillRule: "evenodd",
    xlinkHref: "#path-30"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-31)",
    xlinkHref: "#path-30"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-45",
    stroke: "#2CB5D6",
    strokeWidth: 1.86666667,
    strokeLinecap: "round",
    transform: "translate(73.670222, 25.598785) rotate(248.000000) translate(-73.670222, -25.598785) ",
    points: "63.4294986 28.2072605 71.3749991 22.9903105 83.9109448 27.6553938"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-33)",
    xlinkHref: "#path-32"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#575756",
    strokeWidth: 0.933333333,
    fill: "#F8F8F8",
    fillRule: "evenodd",
    cx: 71.875,
    cy: 28.75,
    r: 3.15
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "runner",
    transform: "translate(68.624213, 47.646174)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-34)",
    cx: 80.234414,
    cy: 161.906247,
    rx: 80.234414,
    ry: 6.09375296
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5085059,73.2563037 L77.1499876,117.101153 C77.0613349,117.371861 76.8614418,117.591913 76.6004706,117.706088 L52.609778,128.202071 C51.7532771,128.576792 51.120426,129.329385 50.8982151,130.237477 L49.9541792,134.095397 C49.5603649,135.704769 50.5457686,137.328672 52.15514,137.722486 C52.644849,137.842318 53.1568605,137.836803 53.6438745,137.706449 L85.735373,129.116893 C86.5016873,128.911783 87.1555674,128.411503 87.5539572,127.725505 L104.332616,98.8338777 L104.332616,98.8338777 L130.186177,105.411517 C130.672488,105.535244 130.991796,106.000226 130.932639,106.498531 L127.072718,139.012776 C126.942762,140.107464 127.423647,141.185241 128.325126,141.819721 L130.318938,143.223007 C131.663092,144.16905 133.519664,143.846318 134.465707,142.502164 C134.662614,142.222395 134.80981,141.91077 134.900827,141.580983 L146.244544,100.478407 C146.602888,99.1799923 146.051918,97.8019157 144.897196,97.1084405 L111.145269,76.8385287 L111.145269,76.8385287 L111.145269,74.7552943 L118.437764,57.3078517 C118.86373,56.288721 120.035211,55.8078655 121.054342,56.2338308 C121.152924,56.2750351 121.248046,56.3240729 121.338793,56.3804735 L133.846854,64.1543417 C134.784996,64.7374053 136.018177,64.4495571 136.60124,63.511415 C136.634242,63.4583149 136.664737,63.4036965 136.692622,63.3477398 L150.640082,35.3601173 C151.13275,34.3715063 150.730709,33.1706921 149.742098,32.6780239 C149.377644,32.4964005 148.966434,32.4303513 148.563434,32.4887053 L145.703435,32.9028303 C143.843759,33.1721095 142.217639,34.2970636 141.309864,35.9423138 L134.416459,48.4359118 C134.149651,48.9194737 133.541356,49.0951877 133.057794,48.82838 C132.97649,48.7835199 132.90183,48.7275538 132.835967,48.6620948 L118.467625,34.3819803 C116.863182,32.7873888 114.840701,31.6787665 112.633412,31.1839583 L101.77397,28.7495963 C99.1556173,28.1626399 96.416085,28.470202 93.993067,29.6231435 L70.1731773,40.9573311 C68.6313162,41.6909929 67.4750795,43.0468393 66.9941189,44.6852142 L60.6204788,66.3967885 C60.3981791,67.1540446 60.6419848,67.9712199 61.2428675,68.4828781 L62.9236846,69.9141121 C63.9953017,70.8266058 65.6037412,70.6976107 66.5162348,69.6259936 C66.6892211,69.4228415 66.8292305,69.1937833 66.9311463,68.9471902 L74.572413,50.458561 C74.7982662,49.9120919 75.254357,49.4935733 75.8181819,49.315417 L88.8942435,45.1836699 C89.9474849,44.8508688 91.0710942,45.4349011 91.4038952,46.4881424 C91.4570809,46.6564633 91.4877485,46.8310848 91.4950986,47.0074555 L92.5134529,71.4434486 L92.5134529,71.4434486 L91.5085059,73.2563037 Z",
    id: "Path-12",
    fill: "url(#linearGradient-35)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-36"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-37)",
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.842981,27.3080075 C118.113136,27.3080075 125.466725,22.2758721 125.466725,16.0684187 C125.466725,9.86096516 118.113136,4.82882985 111.842981,4.82882985 C105.572826,4.82882985 100.489861,9.86096516 100.489861,16.0684187 C100.489861,22.2758721 105.572826,27.3080075 111.842981,27.3080075 Z",
    id: "Oval",
    fill: "url(#linearGradient-38)",
    transform: "translate(112.978293, 16.068419) rotate(-245.000000) translate(-112.978293, -16.068419) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(98.374497, 77.770656) rotate(54.000000) translate(-98.374497, -77.770656) translate(96.605757, 72.238366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58930685,0 C3.90858042,3.27191227 3.4617592,6.54382454 1.2488432,9.81573681",
    id: "Path-15",
    stroke: "#F8F8F8",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 1.2488432,
    cy: 9.81573681,
    r: 1.2488432
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(101.716822, 80.525012) rotate(33.000000) translate(-101.716822, -80.525012) translate(100.455482, 74.794846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.709803729,0 C0.709803729,0 2.5226795,4.51253564 1.44671084,9.79607119",
    id: "Path-15",
    stroke: "#F8F8F8",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 1.2738363,
    cy: 10.2114884,
    r: 1.2488432
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarBodyIcon);
export default __webpack_public_path__ + "static/media/pillar-body-icon.7f0966ac847f8c5f5e9770e45a3ab8dd.svg";
export { ForwardRef as ReactComponent };